import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RunningWithErrorsRoundedIcon from '@mui/icons-material/RunningWithErrorsRounded';
import Tooltip from '@src/components/Tooltip';
import SpeedNew from '@src/components/SpeedNew';
import BadgeAvatar from '@src/components/BadgeAvatar';
import BreakTime from '@src/components/BreakTime';
import { convertFormatDate } from '@src/utils/date';
import { SUB_STATUS } from '@src/constants/voiceCloning';

const ConfigOptionBlock = ({
  handleOpenVoices,
  handleChangeSpeed,
  handleChangeBreakTime,
  voice,
  speed,
  breakTime,
  isSynthesizing,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);

  const isInValidPublicVoiceCloning =
    voice?.userId !== user?.id &&
    voice?.discardAt &&
    moment().isAfter(voice?.discardAt);

  const isPublicVoiceCloning = voice?.status === SUB_STATUS.PUBLIC;
  const isVoiceCloningAboutToRemoved =
    isPublicVoiceCloning && voice?.discardAt
      ? moment().isBefore(voice?.discardAt)
      : false;

  return (
    <div className="config-toolbar">
      <Tooltip arrow title={t('chooseVoice')} placement="top">
        <Button
          onClick={handleOpenVoices}
          className="choose-voice margin-right"
          data-id="open-voice-list"
          disabled={isSynthesizing}
        >
          <BadgeAvatar
            width={25}
            smallImgWidth={10}
            img={voice?.roundImage}
            smallImg={voice?.language?.roundImage}
            type="image"
          />
          <Typography
            variant="body2"
            className={
              isInValidPublicVoiceCloning ? 'invalid-voice-name' : 'voice-name'
            }
          >
            {voice && voice.name}
          </Typography>
        </Button>
      </Tooltip>
      {isVoiceCloningAboutToRemoved && (
        <Tooltip
          arrow
          title={t('voiceCloningDiscardAt', {
            date: convertFormatDate(voice?.discardAt),
          })}
          placement="top"
        >
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      {isInValidPublicVoiceCloning && (
        <Tooltip arrow title={t('invalidPublicVoiceCloning')} placement="top">
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      <SpeedNew
        currentSpeed={speed}
        disabled={isSynthesizing}
        onChange={handleChangeSpeed}
        width="55px"
      />
      <BreakTime
        currentBreakTime={breakTime}
        disabled={isSynthesizing}
        onChange={handleChangeBreakTime}
        tooltipTitle="customBreakTime"
        width="45px"
      />
    </div>
  );
};

export default ConfigOptionBlock;
